export default __webpack_public_path__ + "static/media/hunters_lodge.599eec87.png";